import styled from "@emotion/styled";
import { Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  companiesSelector,
  getCompanies,
  getFloors,
  setCurrentId,
} from "../redux/slices/companiesSlice";

import Home from "./home";
import Details from "./details";
import Cloudbeds from "./cloudbeds";

import LocationBar from "../components/LocationBar";
import Sidebar from "../components/Sidebar";
import Loader from "../components/Loader";

const Wrapper = styled.div`
  display: flex;
`;

const MainWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const Layout = () => {
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const { loading, companiesList } = useSelector(companiesSelector);
  const showLocationBar = pathname !== "/cloudbedsoAuth2";

  useEffect(() => {
    const asyncGetCompanies = async () => {
      const companiesPayload = await dispatch(getCompanies());
      const companies = Array.isArray(companiesPayload.payload)
        ? companiesPayload.payload
        : [];
      const firstCompany = companies[0];

      if (!firstCompany?.company_id) return;

      dispatch(setCurrentId(firstCompany.company_id));
      dispatch(getFloors());
    };

    asyncGetCompanies();
  }, [dispatch]);

  if (loading) {
    return (
      <Wrapper>
        <Sidebar />
        <Loader />
      </Wrapper>
    );
  }

  if (!companiesList.length) {
    return (
      <Wrapper>
        <Sidebar />
        <p>No Companies</p>
      </Wrapper>
    );
  }

  return (
    <Wrapper>
      <Sidebar />
      <MainWrapper>
        {showLocationBar && <LocationBar />}
        {<Route exact path="/cloudbedsoAuth2" component={Cloudbeds} />}
        {<Route path="/details" component={Details} />}
        {<Route exact path="/" component={Home} />}
      </MainWrapper>
    </Wrapper>
  );
};

export default Layout;

